"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  WifiSignal: ['wifi-signal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,24a1,1,0,0,1-1-1V12a1,1,0,1,1,2,0V23A1,1,0,0,1,12,24Z', 'M16,15.248a1,1,0,0,1-1-1v-2a3,3,0,1,0-6,0v2a1,1,0,0,1-2,0v-2a5,5,0,0,1,10,0v2A1,1,0,0,1,16,15.248Z', 'M19.5,15a1,1,0,0,1-1-1V12a6.5,6.5,0,0,0-13,0v2a1,1,0,0,1-2,0V12a8.5,8.5,0,0,1,17,0v2A1,1,0,0,1,19.5,15Z', 'M23,15a1,1,0,0,1-1-1V12A10,10,0,0,0,2,12v2a1,1,0,0,1-2,0V12a12,12,0,0,1,24,0v2A1,1,0,0,1,23,15Z']],
  RssFeed: ['rss-feed', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.5,8.267a1.5,1.5,0,0,0,0,3A11.1,11.1,0,0,1,12.938,22.259a1.5,1.5,0,0,0,3,0A14.069,14.069,0,0,0,1.5,8.267Z', 'M1.531.237a1.5,1.5,0,0,0,0,3C12.448,3.237,21,11.592,21,22.259a1.5,1.5,0,0,0,3,0C24,9.91,14.13.237,1.531.237Z', 'M0.000 20.248 A3.500 3.500 0 1 0 7.000 20.248 A3.500 3.500 0 1 0 0.000 20.248 Z']],
  WifiSignal3: ['wifi-signal-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13,14.226V11.5a1,1,0,1,0-2,0v2.728L6.138,22.491A1,1,0,0,0,7,24H17a1,1,0,0,0,.862-1.507Z', 'M12,0A12,12,0,0,0,3.332,20.293,1,1,0,0,0,4.777,18.91a10,10,0,1,1,14.446,0,1,1,0,0,0,1.445,1.383A12,12,0,0,0,12,0Z', 'M12,5.184a6.508,6.508,0,0,0-6.5,6.5,6.442,6.442,0,0,0,1.221,3.783A1,1,0,1,0,8.345,14.3,4.456,4.456,0,0,1,7.5,11.684a4.5,4.5,0,0,1,9,0,4.456,4.456,0,0,1-.845,2.616,1,1,0,1,0,1.624,1.167A6.442,6.442,0,0,0,18.5,11.684,6.508,6.508,0,0,0,12,5.184Z']],
  RssFeedSquare: ['rss-feed-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,0H4A4,4,0,0,0,0,4V20a4,4,0,0,0,4,4H20a4,4,0,0,0,4-4V4A4,4,0,0,0,20,0ZM5.5,11a1,1,0,0,1,0-2A9.511,9.511,0,0,1,15,18.5a1,1,0,0,1-2,0A7.509,7.509,0,0,0,5.5,11Zm4,6A2.5,2.5,0,1,1,7,14.5,2.5,2.5,0,0,1,9.5,17ZM5.5,6a1,1,0,0,1,0-2A14.517,14.517,0,0,1,20,18.5a1,1,0,0,1-2,0A12.514,12.514,0,0,0,5.5,6Z']],
  WifiSignal5: ['wifi-signal-5', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.25,13.137V9.873a1.25,1.25,0,1,0-2.5,0v3.264L6.105,22.426A1,1,0,0,0,7,23.873H17a1,1,0,0,0,.895-1.447Z', 'M12,5.123a1.25,1.25,0,0,0,1.25-1.25v-2.5a1.25,1.25,0,1,0-2.5,0v2.5A1.25,1.25,0,0,0,12,5.123Z', 'M17.48,6.661l1.768-1.768A1.25,1.25,0,0,0,17.48,3.125L15.712,4.893A1.25,1.25,0,0,0,17.48,6.661Z', 'M21,9.123H18.5a1.25,1.25,0,0,0,0,2.5H21a1.25,1.25,0,0,0,0-2.5Z', 'M6.52,6.661A1.25,1.25,0,0,0,8.288,4.893L6.52,3.125A1.25,1.25,0,0,0,4.752,4.893Z', 'M6.75,10.373A1.25,1.25,0,0,0,5.5,9.123H3a1.25,1.25,0,0,0,0,2.5H5.5A1.25,1.25,0,0,0,6.75,10.373Z']],
  WifiSignal4: ['wifi-signal-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.041,11.933a3,3,0,1,0-2.082,0L7.06,22.656A1,1,0,0,0,8,24h8a1,1,0,0,0,.94-1.342Z', 'M20.339.291a1,1,0,1,0-1.414,1.414,10.515,10.515,0,0,1,0,14.85,1,1,0,1,0,1.414,1.414A12.516,12.516,0,0,0,20.339.291Z', 'M5.075,1.705A1,1,0,0,0,3.661.291a12.516,12.516,0,0,0,0,17.678,1,1,0,1,0,1.414-1.414A10.515,10.515,0,0,1,5.075,1.705Z', 'M17.053,3.827a1,1,0,0,0-1.414,1.414,5.5,5.5,0,0,1,0,7.778,1,1,0,0,0,1.414,1.414,7.5,7.5,0,0,0,0-10.606Z', 'M8.361,14.433a1,1,0,0,0,0-1.414,5.5,5.5,0,0,1,0-7.778A1,1,0,0,0,6.947,3.827a7.5,7.5,0,0,0,0,10.606A1,1,0,0,0,8.361,14.433Z']],
  WifiSignal2: ['wifi-signal-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.339,1.666A1,1,0,1,0,18.925,3.08a10.5,10.5,0,0,1,0,14.85,1,1,0,0,0,1.414,1.415,12.5,12.5,0,0,0,0-17.679Z', 'M17.509,4.494A1,1,0,0,0,16.1,5.91a6.5,6.5,0,0,1,0,9.192,1,1,0,0,0,1.415,1.414,8.5,8.5,0,0,0,0-12.022Z', 'M2,10.506A10.436,10.436,0,0,1,5.075,3.08,1,1,0,0,0,3.661,1.666a12.5,12.5,0,0,0,0,17.679A1,1,0,0,0,5.075,17.93,10.428,10.428,0,0,1,2,10.506Z', 'M7.9,4.494a1,1,0,0,0-1.415,0,8.5,8.5,0,0,0,0,12.02A1,1,0,1,0,7.9,15.1a6.5,6.5,0,0,1,0-9.193A1,1,0,0,0,7.9,4.494Z', 'M12,7.373a2.993,2.993,0,0,0-1,5.816v8.434a1,1,0,1,0,2,0V13.189a2.993,2.993,0,0,0-1-5.816Z']],
  WifiSignal1: ['wifi-signal-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.500 11.998 A1.500 1.500 0 1 0 13.500 11.998 A1.500 1.500 0 1 0 10.500 11.998 Z', 'M15.536,8.462a1,1,0,0,0-1.414,1.414,3.005,3.005,0,0,1,0,4.243,1,1,0,0,0,1.414,1.415A5.008,5.008,0,0,0,15.536,8.462Z', 'M9.878,8.462a1,1,0,0,0-1.414,0,5.008,5.008,0,0,0,0,7.072,1,1,0,0,0,1.414-1.415,3.005,3.005,0,0,1,0-4.243A1,1,0,0,0,9.878,8.462Z', 'M18.01,5.988A1,1,0,0,0,16.6,7.4a6.5,6.5,0,0,1,0,9.192,1,1,0,1,0,1.414,1.414,8.5,8.5,0,0,0,0-12.02Z', 'M5.5,12A6.455,6.455,0,0,1,7.4,7.4,1,1,0,0,0,5.99,5.988a8.5,8.5,0,0,0,0,12.02A1,1,0,1,0,7.4,16.594,6.455,6.455,0,0,1,5.5,12Z', 'M20.485,3.513a1,1,0,1,0-1.414,1.414,10.011,10.011,0,0,1,0,14.142,1,1,0,1,0,1.414,1.414A12.013,12.013,0,0,0,20.485,3.513Z', 'M4.929,4.927A1,1,0,1,0,3.515,3.513a12.013,12.013,0,0,0,0,16.97,1,1,0,1,0,1.414-1.414A10.011,10.011,0,0,1,4.929,4.927Z']]
};
exports["default"] = _default;